import { DefaultValues } from "react-hook-form";
import * as yup from "yup";

export const preReservationFormSchema = yup
  .object({
    id: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value,
      )
      .optional(),
    name: yup.string().required("Името е задължително").defined(),
    templateText: yup
      .string()
      .required("Съдържанието е задължително")
      .max(10000, "Максимум 10000 символа")
      .defined(),
    isDeleted: yup.boolean().optional(),
  })
  .required();

export type IPreReservationFormInputModel = yup.InferType<
  typeof preReservationFormSchema
>;

export const getPreReservationFormDefaults =
  (): DefaultValues<IPreReservationFormInputModel> => ({
    name: "",
    templateText: "",
  });
